/**
 * @file       Month/Year pick directive
 * @version    2.0.0
 * @author     Boris Veits
 * @copyright  Copyright (c) 2018, MindShare HDV LLC.  All rights reserved.
 *             Property of MindShare HDV LLC.  This file cannot be used or 
 *             altered in anyway without expressed written permission from 
 *             MindShare HDV LLC.
 */
import { Directive, ElementRef, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive
({
    selector: '[monthYear]',
    standalone: false
})
/**
 * @desc   - directive for allwing only numbers with one dash
 */    
class MonthYearDirective 
{

    /**
     * @desc   - directive for allwing only numbers with one dash
     */      
    constructor
    (
        private el: ElementRef,
        private ngControl: NgControl
    ) 
    {
    }

    //______________________ S T A T I C  M E T H O D S ________________________

    //__________________ P R I V A T E  M E T H O D S __________________________
    
    //___________________ P U B L I C  M E T H O D S ___________________________
    
    /**
     * @desc   - handle the user typing in the field
     * @access - public
     * @param  -
     * @return - 
     */    
    @HostListener('input', ['$event'])
    onInput
    (
        event: InputEvent
    ) 
    {
        let input;
        let inputValue;
        let sanitizedInput;
        let parts;
        let monthPart;
        let yearPart;
        let monthNum;
        let slashCount;
        let finalValue;

        input = event.target as HTMLInputElement;
        inputValue = input.value;

        sanitizedInput = inputValue.replace(/[^0-9/]/g, '');
        slashCount = sanitizedInput.split('/').length - 1;

        if (slashCount > 1) 
        {
            sanitizedInput = sanitizedInput.slice(0, sanitizedInput.lastIndexOf('/'));
            slashCount = 1;
        }

        parts = sanitizedInput.split('/');
        monthPart = parts[0] || '';
        yearPart = parts[1] || '';

        if (monthPart.length > 2) 
        {
            monthPart = monthPart.slice(0, 2);
        }
        if (monthPart.length === 2) 
        {
            monthNum = Number(monthPart);
            if (monthNum < 1 || monthNum > 12) 
            {
                monthPart = monthPart.slice(0, 1);
            }
        }

        if (yearPart.length > 4) 
        {
            yearPart = yearPart.slice(0, 4);
        }

        finalValue = monthPart;
        if (monthPart.length === 2 && sanitizedInput.indexOf('/') === -1) 
        {
            finalValue += '/';
        }
        if (sanitizedInput.indexOf('/') !== -1) 
        {
            finalValue = monthPart + '/' + yearPart;
        }

        if (this.ngControl?.control) 
        {
            this.ngControl.control.setValue(finalValue, { emitEvent: false });
            input.value = finalValue; 
        } 
        else 
        {
            input.value = finalValue;
        }
    }
}

export { MonthYearDirective }